
import React, { Component } from "react";
import './style.css';

class Calendly extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const scheduleFormDiv = document.getElementById("schedule-form");
    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("id", "calendly-app");
    script.innerHTML = `
        Calendly.initInlineWidget({
            url: 'https://calendly.com/atlighthouse/30min'    
    });
    `;

    scheduleFormDiv.appendChild(script);
  }

  render() {
    return <div className="calendly-form" id="schedule-form" />;
  }
}

export default Calendly;

